import React from "react";
import Image from "../../elements/Image";
import Button from "../../form/Button";
import ManHolding from "../../../assets/images/man-holding.webp";
import HiphopStyle from "../../../assets/images/hip-hop-style.webp";
import DanceTherapy from "../../../assets/images/dance-therapy.webp";
import BalletDancers from "../../../assets/images/ballet-dancers.webp";
import { useTranslation } from "react-i18next";

const HomeBanner = () => {
  const { t } = useTranslation();
  const imageBlocks = [
    { src: ManHolding, className: "rounded-br-full" },
    { src: HiphopStyle, className: "rounded-bl-full" },
    { src: DanceTherapy, className: "rounded-tr-full" },
    { src: BalletDancers, className: "rounded-tl-full" },
  ];
  const heroContent = {
    title: `${t("plan")}. ${t("promote")}. ${t("perform")}.`,
    subtitle: [
      `${t("the_all-in-one_platform_for_organising_unforgettable")}`,
      t("dance_events_From_studio_showcases_to_global_competitions"),
    ],
    button: {
      label: t("Get_Started_for_Free"),
    },
  };
  return (
    <section className="relative py-12 2xl:py-16 bg-white lg:px-0">
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 px-6">
        <div className="relative">
          <div className="max-w-2xl 2xl:max-w-3xl w-full aspect-[15/14] overflow-hidden rounded-r-full flex items-center">
            <div className="grid grid-cols-2 gap-4 w-full">
              {imageBlocks.map((img, index) => (
                <div
                  key={index}
                  className={`relative w-full aspect-square overflow-hidden flex ${img.className}`}
                >
                  <Image
                    src={img.src}
                    width={"100%"}
                    height={"100%"}
                    alt={""}
                    classes={"object-cover"}
                    effect={"blur"}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="relative space-y-4 2xl:space-y-8 flex flex-col justify-center items-center">
          <h1 className="text-3xl xl:text-4xl 2xl:text-5xl font-bold capitalize text-deep-purple text-center">
            {heroContent.title}
          </h1>
          <div className="text-deep-purple text-xl xl:text-2xl 2xl:text-3xl text-center space-y-2">
            {heroContent.subtitle.map((line, i) => (
              <p key={i} dangerouslySetInnerHTML={{ __html: line }} />
            ))}
          </div>
          <div className="relative">
            <Button
              buttonLabel={heroContent.button.label}
              buttonLabelClasses={"text-lg 2xl:text-xl text-white uppercase"}
              buttonClasses={"!bg-secondary-gradient h-12 2xl:h-16"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
